export const SITE = {
  name: "Map Observer",
  tagline: "The authority on local SEO, Google Maps & Business Profile",
  shortTagline: "The authority for agencies & local operators",
  description:
    "The authoritative daily briefing on Google Business Profile, the Map Pack, and local search — read by local SEO agencies, GBP specialists, and the multi-location operators they serve.",
  url: "https://mapobserver.com",
  twitter: "@mapobserver",
} as const;

/**
 * GBPly founded and funds Map Observer. Every reader-facing mention of the
 * relationship reads from here so the wording can never drift between the
 * footer, article pages, the sponsor page, and the funding disclosure.
 */
export const SPONSOR = {
  name: "GBPly",
  domain: "gbply.net",
  url: "https://gbply.net",
  tagline: "A Smarter Way to Manage Google Business Profiles",
  page: "/sponsors/gbply",
  /**
   * rel for outbound links to the sponsor. `sponsored` is the attribution
   * Google requires for paid/funded links; it stays crawlable and still
   * carries the brand and entity signal, without the paid-link-scheme risk
   * that a sitewide plain-follow link would create for both domains.
   */
  rel: "sponsored noopener",
} as const;


export type CategorySummary = { slug: string; name: string };

export function readingMinutesFor(markdown: string): number {
  const words = markdown.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 220));
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "";
  return new Date(value).toLocaleDateString("en-US", {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatShortDate(value: string | null | undefined): string {
  if (!value) return "";
  return new Date(value).toLocaleDateString("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
  });
}

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

/**
 * Google's source-preferences deeplink. Readers who follow it can mark
 * Map Observer as a preferred source, which lifts our stories in their
 * Top Stories and badges them in AI Overviews / AI Mode.
 * https://developers.google.com/search/docs/appearance/preferred-sources
 */
export const PREFERRED_SOURCE_DEEPLINK =
  "https://www.google.com/preferences/source?q=mapobserver.com";
